import DiseaseItem from './DiseaseItemValue'

export default DiseaseItem
